import { BallotView } from "./BallotView"
import type { Bus } from "./lib/Bus"
import {
  CandidateID,
  phenom,
  PollCRDT,
  withBallot,
  withCandidate,
  withCandidateDeleted,
  withTitle,
} from "./poll"
import { SplashGrid } from "./SplashGrid"

import type { Item } from "./EditableList"

import chaos from "./chaos"
import { InviteButton } from "./InviteButton"

interface Props {
  pollBus: Bus<PollCRDT>
  activeProfile: string
  setProfileID: (id: string) => void 
}

export function PollController({ pollBus, activeProfile, setProfileID }: Props): JSX.Element {
  ;(window as any).chaos = chaos.chaos(pollBus)
  ;(window as any).shuffle = chaos.shuffle(pollBus)

  return (
    <SplashGrid>
      <BallotView
        setProfileID={setProfileID} 
        activeProfile={activeProfile}
        onAddCandidate={(candidate: Item) =>
          pollBus.apply(withCandidate(candidate, pollBus.state.get()))
        }
        setTitle={(title: string) =>
          pollBus.apply(withTitle(title, pollBus.state.get()))
        }
        onBallotUpdated={(ranking) =>
          pollBus.apply(withBallot(activeProfile, ranking, pollBus.state.get()))
        }
        onRemoveItem={(id: CandidateID) =>
          pollBus.apply(withCandidateDeleted(id, pollBus.state.get()))
        }
        poll={phenom({ ...pollBus.state.get(), id: pollBus.id })}
      />
      <InviteButton url={window.location.toString()} />
    </SplashGrid>
  )
}
